import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ZakatDonationForm',
  props: {
  zakatAmount: {
    type: Number,
    required: true,
    default: 0
  },
  currencies: {
    type: Object,
    default: () => ({})
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  symbol: {
    type: String,
    default: '$'
  },
  show_currency_dropdown: {
    type: Boolean,
    default: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();

const props = __props;

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt) => {
  const { exchange_rates } = lifeline_donation || {};
  const syb = getSymbol();
  if(_.get && _.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt;
};

const formatAmount = (amount) => {
  const convertedAmount = convert(amount);
  return parseFloat(convertedAmount).toFixed(2);
};

const onCurrencyChange = () => {
  // Handle currency conversion if needed
  console.log('Currency changed to:', store.currency);
};

// Set the zakat amount in the store
store.amount = props.zakatAmount;
store.extras.donation_purpose = 'Zakat';

const __returned__ = { store, props, lifeline_donation, _, getSymbol, convert, formatAmount, onCurrencyChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})